import { makeNoteMockData } from '../../modules/noteMockDataFactory'
import type { IOrderMSServiceNote } from '~/types/note/models'

export const {
  getNoteListData: getOrderMSServiceNoteListData,
  getNoteDataById: getOrderMSServiceNoteDataById,
  getNoteListDataByParentId: getOrderMSServiceNoteListDataByOMSSId,
} = makeNoteMockData<IOrderMSServiceNote>({
  entityName: 'orderMSService',
  storageKeyPrefix: 'ordermsservice',
})
